<!-- qrGenerator.vue -->
<template>
  <div class="justify-center ">
    <label class="mt-10">URL</label>
    <vs-input v-model="url" class="w-6/12 my-3" />

    <label class="mt-10">Color</label
    ><vs-input class="w-6/12 my-3" type="color" v-model="color" />

    <label class="mt-10">Background Color</label>
    <vs-input class="w-6/12 my-3" type="color" v-model="backgroundColor" />

    <label class="mt-10">Size</label>
    <vs-input class="w-6/12 my-3" type="number" v-model="size" value="500" />

    <!-- URL:{{ url }}<br />
    color:{{ color }}<br />
    backgroundColor:{{ backgroundColor }}<br />
    size:{{ size }}<br />-->
    <vs-button
      class="mt-5"
      color="primary"
      type="filled"
      @click="generateQRCode"
      >Generate QR Code</vs-button
    >
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      // id: this.$route.params.id,
      url: "https://qrrate.chakrasuria.net/live/survey/demo",
      color: "#000000",
      backgroundColor: "#FFFFFF",
      size: 300
    };
  },
  // computed: {
  //   // aaa
  // },
  methods: {
    // getData(from) {},
    generateQRCode() {
      // Ensure that url, color, bgColor, and size are defined
      if (this.url && this.color && this.backgroundColor && this.size) {
        const qrCodeUrl = `/qrcode/${encodeURIComponent(
          this.url
        )}/${encodeURIComponent(this.color)}/${encodeURIComponent(
          this.backgroundColor
        )}/${this.size}`;

        this.$router.push(qrCodeUrl);
      } else {
        // Handle case where data is not complete
        console.error("Incomplete data for QR code generation");
      }
    }
  },
  watch: {},
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
